import EditParents from './EditParents';

export default EditParents;
